import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const WebSubHeader = () => import(/* webpackChunkName: "4-feat-web-sub-header" */ './WebSubHeader');

export default lazyLoadOnRender({ loader: WebSubHeader });
